<template>
    <v-row>
        <v-col>
            <h1>Nova versão</h1>
        </v-col>
        <v-col cols="12">
            <p>
                A fim de melhorar o site, fizemos várias mudanças referente a nova versão, com o foco
                na melhoria visual e no mecânismo de busca, garantindo a melhor experiêcia para os nossos usuários.
                acesse a nova versão clicando no botão do menu ou clicando <a href="https://homolog.listademusicas.com.br/home">aqui!</a>
            </p>
            <p>
                <b>Caso você não curta o novo visual, fique a vontade de voltar para o antigo acessando:
                    <a href="https://listademusicas.com.br/#/">www.listademusicas.com.br</a>
                </b>
            </p>
            <h2>Novidades</h2>
            <ul>
                <li>
                    Mudanças visuais: Melhoramos o contexto geral visual da aplicação, garantindo
                    o uso dos padrões visuais que estão em alta;
                </li>
                <li>
                    Informações nos resultados de pesquisa: Agora você consegue ver o inicio da música
                </li>
                <li>
                    Agora é possível criar um usuário na aplicação e manter as suas músicas 
                    favoritas salvas ao trocar de dispositivo
                </li>
                <li>
                    Pesquisa mais assertiva
                </li>
                <li>
                    Modo escuro
                </li>
                <li>
                    App para download no celular: Após mexer na nova aplicação, você receberá um aviso 
                    sobre a instalação no nosso app, fique ligado!
                </li>
            </ul>
        </v-col>
    </v-row>
</template>

<script>
export default {

}
</script>

<style>

</style>